import Image from 'next/image';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styles from './FaceModal.module.scss';

const Loading = () => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.face_modal_wrap}
      itemScope
      itemType='https://schema.org/StatusUpdate'
    >
      <Image
        src='/assets/load.png'
        layout='fixed'
        width={56}
        height={56}
        alt='loader icon'
        title='Loader Icon'
        className={styles.icon}
        loading='lazy'
      />
      <p className={styles.description}>{t('esim:recognitionInfo.waiting')}</p>
    </div>
  );
};

export default Loading;
